import React from 'react';
import classNames from 'classnames';
import SaveButton from './SaveButton';
import ReloadButton from './ReloadButton';
import messages from '../../../res/translations/messages';
import {FormattedMessage} from 'react-intl';

const FooterToolbar = ({error, dirty}) => {
    let extractedPayload;
    if (error && error.response) {
        extractedPayload = error.response.data.payload;
    }
    return (
        <div className={classNames({'border-danger': error, 'show': dirty || error}, 'btn-toolbar fixed-toolbar')}>
            <div className="container">
                <div className="row">
                    <div className="col">
                        {extractedPayload !== 'SURVEY_CONCURRENT_UPDATE' ?
                            error &&
                                <span>
                                    {error.message}{error.response && error.response.data && error.response.data.message &&
                                        error.response.data.message.length !== 0 && `: ${error.response.data.message}`}
                                </span> :
                            error &&
                                <span>
                                    <FormattedMessage {...messages.errors.concurrentUpdate} />
                                </span>
                        }
                    </div>
                    <div className="col-auto">
                        {extractedPayload !== 'SURVEY_CONCURRENT_UPDATE' ?
                            <ReloadButton modalShow={true} /> : <ReloadButton modalShow={false} />
                        }
                    </div>
                    {extractedPayload !== 'SURVEY_CONCURRENT_UPDATE' &&
                        <div className="col-auto">
                            <SaveButton />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default FooterToolbar;
